<template>
  <div>
    <v-toolbar class="elevation-0" color="none">
      <v-toolbar-title>
        <b class="text-primary">
          {{
            (visa_type_slug === "dependent-visa" &&
            !visa_request.visaType.name.includes("Dependent")
                ? "Dependent "
                : "") + visa_request.visaType.name
          }}
          <span style="color: #212020;font-size: 15px;"
          >(
            {{
              visa_request.condition.toString().toLowerCase() ===
              visa_request.duration.toString().toLowerCase()
                  ? ""
                  : visa_request.condition
            }}
            )</span
          >

          ( {{ visa_request.duration }} days
          {{ visaPlanOptions[visa_request.visa_plan] }} )
          <v-chip class="text-white ml-2" :color="statusColor">
            &nbsp; {{ latest_status }}
          </v-chip>
        </b>
        <v-btn v-if="visa_request.prevNotification" @click="viewVisaRequest(visa_request.prevNotification)"
               class="mx-2"
               fab
               dark
               small
               color="primary"
               title="Previous"
        >
          <v-icon dark>
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <v-btn v-if="visa_request.nextNotification" @click="viewVisaRequest(visa_request.nextNotification)"
               class="mx-2"
               fab
               dark
               small
               color="primary"
               title="Next"
        >
          <v-icon dark>
            mdi-arrow-right
          </v-icon>
        </v-btn>

      </v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-card-text class="pt-0">
      <v-layout class="pb-2" row style="background: #ffffff" wrap>
        <v-flex class="mx-2" xs12>
          <v-flex xs12 v-if="visa_request.expired_at">
            <v-alert outlined type="error">
              This visa has expired.
            </v-alert>
          </v-flex>
          <v-flex
              xs12
              v-if="
              visa_request.expired_at === null &&
                visa_request.expiry_date < today
            "
          >
            <v-alert outlined type="error">
              This visa has expired at {{ visa_request.expiry_date }}.
            </v-alert>
          </v-flex>
          <v-flex
              xs12
              v-if="
              visa_request.extra && visa_request.extra.has_recommendation_letter === true">
            <v-alert outlined type="info">
              Applicant has recommendation letter for free Visa.
            </v-alert>
          </v-flex>
          <v-flex xs12
                  v-if="visa_request.extra.blacklisted_country && visa_request.extra.blacklisted_country === true">
            <v-alert outlined type="error">
              Applicant is from prohibited country.He can not apply for visa without recommendation letter.Please ask
              for recommendation letter.
            </v-alert>
          </v-flex>
          <!-- Checking if the person is in Blacklist-->
          <v-alert
              outlined
              type="error"
              v-if="visa_request.blacklists.length > 0"
          >
            Similar record matching to this person information is found in
            Blacklist.
          </v-alert>

          <!--          checking if the person is in interpol record-->
          <v-alert outlined type="error" v-if="visa_request.interpol_hit">
            Interpol hit found. Immediately contact to INTERPOL (9851285950/ 01-4412836/ 01-4430411)
          </v-alert>
          <v-flex xs12 v-if="visa_request.assigned_user_for_tippani">
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_tippani && visa_request.assigned_user_for_tippani.id === user.id">
              Please approve tippani.
            </v-alert>
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_tippani && visa_request.assigned_user_for_tippani.id !== user.id">
              This visa is assign to {{ visa_request.assigned_user_for_tippani.full_name }} for tippani approve.
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="visa_request.assigned_user_for_penalty">
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_penalty && visa_request.assigned_user_for_penalty.id === user.id">
              Please apply penalty. If you don't want to apply penalty, please forward to user for approve.
            </v-alert>
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_penalty && visa_request.assigned_user_for_penalty.id !== user.id">
              This visa is assign to {{ visa_request.assigned_user_for_penalty.full_name }} for penalty addition.
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="visa_request.assigned_user_for_approve">
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_approve && visa_request.assigned_user_for_approve.id === user.id">
              Please approve visa.
            </v-alert>
            <v-alert outlined type="info"
                     v-if="visa_request.assigned_user_for_approve && visa_request.assigned_user_for_approve.id !== user.id">
              This visa is assign to {{ visa_request.assigned_user_for_approve.full_name }} for visa approve.
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="visa_request.extra.i_am_nrn">
            <v-alert outlined type="info">
              Applicant is an NRN.
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="visa_request.extra.apply_type === 'entry'">
            <v-alert outlined type="info">
              This visa is entry visa.
            </v-alert>
          </v-flex>
          <!--                    Overstay Processing Alert-->
          <v-alert
              outlined
              type="info"
              v-if="visa_request.extra.overstay_processing"
          >
            This request is overstay processing. Corresponding fees and fines
            for overstay will defined by Administration Section.
          </v-alert>
          <!-- Checking if the person is in Watch List-->
          <v-alert outlined type="info" v-if="visa_request.watch_list.length > 0">
            Similar record matching to this person information is found in Watch lists.
          </v-alert>
          <!-- Checking if the visa is cancelled-->
          <v-alert outlined type="error" v-if="visa_request.cancelled">
            This visa has been cancelled
          </v-alert>

          <!-- Checking if the visa is relation/marriage and more than 1 year late -->
          <v-alert outlined type="error" v-if="showGenerateTouristVisa">
            This visa is more than 1 year late, so regulate it through tourist visa first and then to applied visa
          </v-alert>

          <!-- Checking if the visa is late-->
          <v-alert outlined type="error" v-if="showLateDays">
            This visa is <b>{{ visa_request.late_days }}</b> days late
            <span
                v-if="
                visa_request.verified_late_days > 0 &&
                  visa_request.late_days != visa_request.verified_late_days &&
                  !visa_request.approve_rejected
              "
            >and <b>{{ visa_request.verified_late_days }}</b> days late while
              verifying</span
            >
          </v-alert>

          <v-alert outlined type="info" v-if="showDependentApproveMessage">
            This visa is dependent on another visa . Please approve main person
            visa first before approving this one.
          </v-alert>
        </v-flex>

        <black-list-detail
            :black_lists="visa_request.blacklists"
            :traveller_id="visa_request.traveller.id"
            @unmarked="unmarked"
        />
        <v-layout row wrap class="pl-6">
          <confirmation-header-text
              icon="mdi-card-bulleted"
              text="Visa Details"
              class="ml-0"
          />
          <v-flex sm3 v-if="visa_request.visa_number" xs12>
            <list-item-detail
                :sub_title="visa_request.visa_number"
                title="Visa Number"
            />
          </v-flex>
          <v-flex
              sm3
              v-if="
              visa_request.visa_sticker_number &&
                visa_request.visa_sticker_number !== 'null'
            "
              xs12
          >
            <list-item-detail
                :sub_title="visa_request.visa_sticker_number"
                title="Visa Sticker Number"
            />
          </v-flex>
          <v-flex sm3 xs12>
            <list-item-detail
                :sub_title="visa_request.submission_no"
                title="Submission Id"
            />
          </v-flex>
          <v-flex class="pr-4" sm3 v-if="visa_request.new_days_stayed && visa_type_slug ==='tourist-visa'" xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                    hide-details
                    :disabled="visa_request.new_days_stayed.countable_days_stayed > 0"
                    label="Previous Stay"
                    outlined
                    v-model="visa_request.new_days_stayed.countable_days_stayed"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-btn
                    x-small
                    fab
                    @click="confirmUpdatePreviousStay"
                    class="text-white mr-2 "
                    color="orange"
                    v-if="$oauth.checkIfHasPermission('update previous-stay')"
                >
                  <v-icon>mdi-border-color</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm3 v-if="visa_request.start_date" xs12>
            <list-item-detail
                :sub_title="
                `${visa_request.start_date.split(' ')[0]} to ${
                  visa_request.expiry_date
                    ? visa_request.expiry_date
                    : expiryDate
                }`
              "
                title="Visa Duration"
            />
          </v-flex>
          <v-flex
              sm3
              xs12
              v-if="
              visa_request.verified &&
                !visa_request.voucher_generated &&
                !visa_request.tippani_generated
            "
          >
            <span
                class="font-weight-bold"
                style="color: black; font-size: 15px;"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      @click="editForm"
                      class="mr-2"
                      color="#FF8316"
                      dark
                      dense
                      fab
                      v-on="on"
                      x-small
                  >
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit information</span>
              </v-tooltip>
            </span>
          </v-flex>

          <v-flex sm3 v-if="visa_request.expired_at" xs12>
            <list-item-detail
                :sub_title="visa_request.expired_at"
                title="Visa Expired Date"
            />
          </v-flex>

          <v-flex sm3 v-if="visa_request.approved_at" xs12>
            <list-item-detail
                :sub_title="visa_request.approved_at"
                title="Visa Approved Date"
            />
          </v-flex>
        </v-layout>

        <v-flex xs12>
          <v-divider class="mb-2"/>
        </v-flex>

        <v-flex xs12>
          <component v-bind:is="visa_type_slug"/>
        </v-flex>

        <v-flex
            xs12
            v-if="
            visa_request &&
              visa_request.extra &&
              visa_request.extra.hasOwnProperty('reciprocity_visa')
          "
        >
          <reciprocity-visa-duration></reciprocity-visa-duration>
        </v-flex>

        <v-flex xs12>
          <v-divider class="mb-2"/>
        </v-flex>

        <attached-document
            :document_list="visa_request.documents"
            :is_latest="visa_request.isLatestVisa"
            :submission_number="visa_request.submission_no"
            :visa_number="visa_request.visa_number"
            :traveller="visa_request.traveller"
        />

        <v-flex xs12 v-if="visa_request.required_documents">
          <v-divider class="mb-2"/>
        </v-flex>

	      <attached-required-document
			      :document_list="visa_request.required_documents"
			      :submission_no="visa_request.submission_no"
			      :is_verified="visa_request.verified"
			      v-if="visa_request.required_documents"
	      />

	      <v-flex xs12>
          <v-divider class="mb-2"/>
        </v-flex>+

        <v-layout
            class="row wrap mx-0"
            v-if="
            visa_request.previous_visa && visa_request.previous_visa.visa_number
          "
        >
          <v-flex class="d-flex justify-content-between" xs12>
            <confirmation-header-text
                :text="
                visa_request.visa_number
                  ? 'Previous'
                  : 'Current' + ' Visa Details'
              "
                class="ml-2"
                icon="mdi-card-bulleted"
            />

            <v-btn
                @click="view(visa_request.previous_visa.submission_no)"
                color="primary"
                dark
                dense
                small
                text
            >
              View Details
            </v-btn>
          </v-flex>

          <v-flex class="pl-3" sm3 xs12>
            <list-item-detail
                :sub_title="visa_request.previous_visa.visa_number"
                title="Visa number"
            />
          </v-flex>

          <v-flex class="pl-3" sm3 xs12>
            <list-item-detail
                :sub_title="visa_request.previous_visa.submission_no"
                title="Submission Id"
            />
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail
                :sub_title="visa_request.previous_visa.visa_type"
                title="Visa Type"
            />
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail
                :sub_title="
                visa_request.previous_visa.start_date +
                  ' to ' +
                  visa_request.previous_visa.expiry_date
              "
                title="Visa Duration"
            />
          </v-flex>

          <v-flex xs12>
            <v-divider class="mb-2"/>
          </v-flex>
        </v-layout>

        <traveller-detail :mobile_number="visa_request.extra.mobile_number"/>

        <v-flex xs12>
          <v-divider class="mb-2"/>
        </v-flex>
        <payment-detail
            :cost-exempted="visa_request.cost_exempted"
            :paid="visa_request.paid"
            :payment_detail="visa_request.payment_detail"
            :voucher-number="visa_request.voucher_number"
        />
        <visa-tippani-dialog :key="randomTippaniKey" v-model="tippaniDialog"
                             @assignUser="showForwardToUserModal = true"/>
        <forward-to-user-dialog v-model="showForwardToUserModal" :purpose="forwardPurpose"></forward-to-user-dialog>
        <visa-tippani-verification-modal :purpose="tippaniPurpose" @purposeCompleted="proceedCompletedPurpose"/>

        <manual-payment-dialog
            :url="'visa-requests/pay-manually/' + visa_request.submission_no"
            @paid="costExempted"
            v-model="manualPaymentDialog"
        />

        <reject-modal-ui/>
        <unapproved-visa-edit-dialog v-model="manualEditDialog"/>
        <v-flex xs12 style="display: none">
          <extend-convert-tippani-print-content/>
        </v-flex>
        <v-flex xs12 style="display: none">
          <voucher-print-content/>
        </v-flex>
        <v-flex xs12 style="display: none">
          <visa-number-print-content/>
        </v-flex>
      </v-layout>
      <v-footer
          class="sticky"
          color="primary lighten-2"
          fixed
          height="auto"
          v-if="visa_request.can_process"
      >
        <v-layout row wrap>
          <v-spacer/>
          <v-btn
              @click="generateTouristVisa"
              class="text-white ml-2"
              color="green"
              v-if="showGenerateTouristVisa && $oauth.checkIfHasPermission(['regulate-tourist-visa-generation'])"
          >
            Generate Tourist Visa
          </v-btn>
          <v-btn
              @click="verifyTippaniGenerated"
              class="white--text"
              color="primary ml-2"
              v-if="showTippaniVerification"
          >
            Verify Tippani
          </v-btn>
          <v-btn
              @click="generateTippani"
              class="text-white ml-2"
              color="primary"
              v-if="showGenerateTippani"
          >
            Generate tippani
          </v-btn>
          <v-btn
              @click="doNotGenerateTippani"
              class="text-white ml-2"
              color="green"
              v-if="showGenerateTippani && !visa_request.tippani_generated"
          >
            Proceed without tippani
          </v-btn>
          <v-btn
              @click="approveTippaniGenerated"
              class="white--text"
              color="primary ml-2"
              v-if="showApproveTippani"
          >
            Approve Tippani
          </v-btn>
          <v-btn
              @click="forwardToUser"
              class="white--text"
              color="primary ml-2"
              v-if="showForward"
          >
            Forward
          </v-btn>
          <v-btn
              @click="exemptCost"
              class="text-white ml-2"
              color="primary"
              v-if="canExemptCost"
          >
            Exempt cost
          </v-btn>
          <v-btn
              @click="showTransferToNewPassportDialog"
              class="text-white ml-2"
              color="primary"
              v-if="showTransferToNewPassport"
          >
            Transfer to new passport
          </v-btn>
          <v-btn
              @click="penaltyDialog = true"
              class="text-white ml-2"
              color="primary"
              v-if="showPenalty || showPenaltyTemporarily"
          >
            Apply Penalty-10(4)
          </v-btn>
          <v-btn
              @click="showAddBorderPenalty"
              class="text-white ml-2"
              color="primary"
              v-if="showApplyBorderPenalty"
          >
            Add Border Penalty
          </v-btn>
          <v-btn
              @click="print('tippani')"
              class="text-white ml-2"
              color="primary"
              v-if="showPrintTippani"
          >
            Print Tippani
          </v-btn>
          <v-btn
              :loading="voucherLoading"
              @click="generateVoucher"
              class="text-white ml-2"
              color="blue"
              v-if="can_generate_voucher"
          >
            Generate Voucher
          </v-btn>

          <v-btn
              @click="print('voucher')"
              class="text-white ml-2"
              color="blue"
              v-if="
              !visa_request.paid &&
                visa_request.voucher_generated &&
                !visa_request.visa_number
            "
          >
            Print Voucher
          </v-btn>
          <v-btn
              :loading="checkPaymentLoading"
              @click="payManually"
              class="text-white ml-2"
              color="blue"
              v-if="check_payment_status"
          >
            Pay Manually
          </v-btn>
          <v-btn
              :loading="checkPaymentLoading"
              @click="checkPayment"
              class="text-white ml-2"
              color="blue"
              v-if="check_payment_status && total > 0"
          >
            Check Payment
          </v-btn>
          <v-btn
              @click="attachDocument"
              class="white--text"
              color="primary ml-2"
              v-if="showAttachDocuments"
          >
            Attach Document(s)
          </v-btn>
          <v-btn
              @click="approve"
              class="white--text"
              color="primary ml-2"
              v-if="showApprove"
          >
            Approve
          </v-btn>
          <v-btn
              @click="reject"
              class="white--text"
              color="red lighten-1 ml-2"
              v-if="
              !visa_request.approve_rejected &&
                visa_request.can_approve_visa &&
                !visa_request.check_payment_status_only
            "
          >
            Reject
          </v-btn>
          <v-btn
              @click="applyForExtension"
              class="white--text"
              color="primary ml-2"
              v-if="showApplyForExtension"
          >
            Apply for extension
          </v-btn>
          <v-btn
              @click="cancel"
              class="white--text"
              color="red lighten-1 ml-2"
              v-if="
              visa_request.visa_number &&
                !visa_request.cancelled &&
                visa_request.can_approve_visa
            "
          >
            Cancel Visa
          </v-btn>

          <v-btn
              @click="download"
              class="white--text"
              color="primary ml-2"
              v-if="visa_request.visa_number && visa_request.can_approve_visa"
          >
            Download Visa Details
          </v-btn>
          <v-btn
              :loading="visaPrintLoading"
              @click="printNow"
              class="white--text"
              color="primary ml-2"
              v-if="
              visa_request.visa_number &&
                visa_request.visa_print_system_active &&
                !visa_request.cancelled &&
                !visa_request.rejected &&
                visa_request.can_approve_visa &&
                $oauth.checkIfHasPermission(['print-visa-number']) &&  $oauth.checkIfHasPermission(['print-multiple-visa'])
            "
          >
            Print Visa
          </v-btn>
          <v-btn
              :loading="visaPrintLoading"
              @click="printNow"
              class="white--text"
              color="primary ml-2"
              v-if="
              visa_request.visa_number &&
                visa_request.visa_print_system_active &&
                !visa_request.cancelled &&
                !visa_request.rejected &&
                visa_request.can_approve_visa &&
                !visa_request.visa_printed &&
                $oauth.checkIfHasPermission(['print-visa-number']) &&  !$oauth.checkIfHasPermission(['print-multiple-visa'])
            "
          >
            Print Visa
          </v-btn>
        </v-layout>
      </v-footer>
      <approve-modal-ui
          :key="gratisVisaNumber"
          v-if="visa_request.start_date"
          :status="visa_request.status"
          :isGratis="isGratis"
          :visa-number="gratisVisaNumber"
          :visa-start-date="visa_request.start_date ? visa_request.start_date.substr(0, 10): null"
      />
      <reciprocity-duration-modal
          :visa-start-date="
          visa_request && visa_request.start_date
            ? visa_request.start_date.substr(0, 10)
            : null
        "
      ></reciprocity-duration-modal>
      <visa-cancel-modal/>
      <cost-exemption-dialog
          :max-amount="total"
          :url="'visa-requests/exempt-cost/' + visa_request.submission_no"
          @exempted="costExempted"
          v-model="exemptionDialog"
          :payment-detail="visa_request.payment_detail"
      />
      <apply-penalty-dialog
          :submission-no="visa_request.submission_no"
          @applied="costExempted('penalty')"
          v-model="penaltyDialog"
      />
      <attach-file-dialog
          :url="'visa-requests/attach-file/' + visa_request.submission_no"
          @attached="costExempted"
          v-model="attachFileDialog"
          :file-already-attached="fileAlreadyAttached"
      />
      <transfer-to-new-dialog
          :submission_no="visa_request.submission_no"
          v-model="transferToNewDialog"
          @transferred="costExempted"
      />
      <v-dialog
          persistent
          v-model="$store.state.VisaRequestSingle.visaNumberModal"
          width="450"
      >
        <v-card>
          <v-card-title class="title blue darken-3 white--text" default-title
          >{{ visa_request.visaType.name }}
          </v-card-title>
          <v-card-subtitle class="blue darken-3 white--text pb-2" default-title
          >({{ visa_request.condition }})
          </v-card-subtitle>
          <v-card-text class="pa-0">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-list-item-content class="py-0">
                    <v-list-item-subtitle
                        style="font-size: 12px;user-select: text;"
                    >Visa Number (Auto Generated)
                    </v-list-item-subtitle>
                    <v-list-item-title
                        style="font-size: 21px; user-select: text;color: black; font-weight: bold"
                    >
                      {{ visa_request.visa_number }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="!visa_request.visa_print_system_active"
                                          style="font-size: 14px;margin-top: 10px;user-select: text;color: red"
                    >
                      Please , write down visa number carefully on the visa
                      sticker
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <list-item-detail
                      :sub_title="
                      visa_request.approve_details &&
                        visa_request.approve_details.approved_at
                    "
                      title="Visa Approved/Issued On"
                  />
                  <list-item-detail
                      :sub_title="
                        visaPlanOptions[visa_request.visa_plan]
                    "
                      title="Visa Plan"
                  />
                  <list-item-detail
                      :sub_title="visa_request.passport_number"
                      title="Passport Number"
                  />
                  <list-item-detail
                      v-if="visa_request.start_date"
                      :sub_title="
                      `${visa_request.start_date.split(' ')[0]} to ${
                        visa_request.expiry_date
                          ? visa_request.expiry_date
                          : expiryDate
                      } (${visa_request.duration} days)`
                    "
                      title="Visa Duration"
                  />
                  <list-item-detail
                      :sub_title="
                      visa_request.office_name
                    "
                      title="Visa Issued At"
                  />
                  <list-item-detail
                      :sub_title="
                      visa_request.approve_details &&
                        visa_request.approve_details.approved_by
                    "
                      title="Visa Approved/Issued By"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn v-if="visa_request.visa_print_system_active"
                   @click="$store.commit('VisaRequestSingle/setVisaNumberModal',false)"
                   class="white--text"
                   color="red darken-3"
            >Cancel
            </v-btn>
            <v-btn v-if="visa_request.visa_print_system_active"
                   color="success"
                   class="white--text"
                   @click="printNow"
            >Print Visa
            </v-btn>
            <v-btn v-else
                   color="success"
                   class="white--text"
                   @click="$store.commit('VisaRequestSingle/setVisaNumberModal',false)"
            >Done
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          persistent
          v-model="$store.state.VisaRequestSingle.visaNumberPrintModal"
          width="800"
      >
        <v-card>
          <v-card-title class="title blue darken-3 white--text" default-title
          >{{ "Print" }}
          </v-card-title>
          <!--          <v-card-subtitle class="blue darken-3 white&#45;&#45;text pb-2" default-title>({{ visa_request.condition }})-->
          <!--          </v-card-subtitle>-->
          <v-card-text class="pa-0">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <visa-number-print-content
                      :show-only="true"
                  ></visa-number-print-content>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                color="red darken-3"
                class="white--text"
                @click="
                $store.commit(
                  'VisaRequestSingle/setVisaNumberPrintModal',
                  false
                )
              "
            >Cancel
            </v-btn>
            <v-btn
                color="primary"
                class="white--text"
                @click="print('initial_visa_number')"
            >Print
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </div>
</template>
<style>
.hide {
  display: none;
}
</style>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import {
  SET_GENERATED_TIPPANI,
  SET_PRINT_CONTENT,
  SET_PRINT_TYPE,
  SET_PRINT_CONTENT_ONLY,
  SET_SELECTED_TIPPANI,
} from "../../../store/mutation-type";
import ExtendConvertTippaniPrintContent from "../../../components/visa/ExtendConvertTippaniPrintContent";

import {validationMixin} from "../../../mixins/validationMixin";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import TouristVisa from "@/components/visa-types/confirm/TouristVisa";
import StudyVisa from "@/components/visa-types/confirm/StudyVisa";
import BusinessVisa from "@/components/visa-types/confirm/BusinessVisa";
import RelationVisa from "@/components/visa-types/confirm/RelationVisa";
import TransitVisa from "@/components/visa-types/confirm/TransitVisa";
import MarriageVisa from "@/components/visa-types/confirm/MarriageVisa";
import ResidentialVisa from "@/components/visa-types/confirm/ResidentialVisa";
import NRNVisa from "@/components/visa-types/confirm/NRNVisa";
import PressVisa from "@/components/visa-types/confirm/PressVisa";
import DependentVisa from "../../../components/visa-types/confirm/DependentVisa";
import WorkingVisa from "../../../components/visa-types/confirm/WorkingVisa";
import OfficialVisa from "../../../components/visa-types/confirm/OfficialVisa";
import DiplomaticVisa from "../../../components/visa-types/confirm/DiplomaticVisa";
import ReciprocityVisaDuration from "../../../components/visa-types/confirm/ReciprocityVisaDuration";

import ListItemDetail from "../../../components/ListItemDetail";
import FileListItemDetail from "../../../components/FileListItemDetail";
import PaymentDetail from "../../../components/PaymentDetail";
import AttachedDocument from "../../../components/AttachedDocument";

import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import VisaApproveModal from "../../../components/visa/VisaApproveModal";
import VisaRejectModal from "../../../components/visa/VisaRejectModal";
import VisaCancelModal from "../../../components/visa/VisaCancelModal";
import AvatarImageModal from "../../../components/AvatarImageModal";
import FileDisplay from "../../../components/FileDisplay";
import DialogFile from "../../../components/FileDisplay";
import BlackListDetail from "../../../components/visa/BlackListDetail";

import {mapActions, mapGetters} from "vuex";
import TravellerDetail from "./TravellerDetail";
import ApplyPenaltyDialog from "../../../components/dialogs/ApplyPenaltyDialog";
import moment from "moment";
import AttachFileDialog from "../../../components/dialogs/AttachFileDialog";
import VisaTippaniDialog from "../../../components/dialogs/VisaTippaniDialog";
import TransferToNewDialog from "../../../components/dialogs/TransferToNewDialog";
import UnapprovedVisaEditDialog from "../../../components/dialogs/UnapprovedVisaEditDialog";

import DependentStudyVisa from "../../../components/visa-types/confirm/DependentStudyVisa";
import DependentWorkingVisa from "../../../components/visa-types/confirm/DependentWorkingVisa";
import DependentBusinessVisa from "../../../components/visa-types/confirm/DependentBusinessVisa";
import DependentPressVisa from "../../../components/visa-types/confirm/DependentPressVisa";
import DependentOfficialVisa from "@/components/visa-types/confirm/DependentOfficialVisa";
import DependentDiplomaticVisa from "@/components/visa-types/confirm/DependentDiplomaticVisa";
import DependentMarriageVisa from "@/components/visa-types/confirm/DependentMarriageVisa";
import DependentRelationVisa from "@/components/visa-types/confirm/DependentRelationVisa";
import VisaNumberPrintContent from "@/components/visa/VisaNumberPrintContent";
import ReciprocityDurationModal from "@/components/visa/ReciprocityDurationModal";
import ReciprocityVisa from "@/components/visa/form/ReciprocityVisa";
import VoucherPrintContent from "../../../components/visa/VoucherPrintContent";
import ForwardToUserDialog from "@/components/dialogs/ForwardToUserDialog";
import AttachedRequiredDocument from "../../../components/AttachedRequiredDocument";
import VisaTippaniVerificationModal from "../../../components/visa/VisaTippaniVerificationModal.vue";

const year_logs = [
  {
    year: new Date().getFullYear(),
    visa_type: null,
    days_stayed: 0,
  },
];
const years = [];
for (let i = new Date().getFullYear(); i > 2017; i--) {
  years.push(i);
}

export default {
  name: "ConditionalPaidVisaDetail",
  props: ["visa_request", "checkPaymentLoading", "voucherLoading"],
  mixins: [validationMixin],
  data() {
    return {
      randomTippaniKey: false,
      tippaniDialog: false,
      step: 1,
      quill: null,
      hide: false,
      manualPaymentDialog: false,
      exemptionDialog: false,
      penaltyDialog: false,
      year_logs,
      years,
      visaPlanOptions: ["", "Plain", "Single Re-entry", "Multiple Re-entry"],
      attachFileDialog: false,
      transferToNewDialog: false,
      manualEditDialog: false,
      today: moment().format("YYYY-MM-DD"),
      visaPrintLoading: false,
      showForwardToUserModal: false,
      forwardPurpose: null,
      tippaniPurpose: null,

    };
  },
  components: {
    VisaTippaniVerificationModal,
	  AttachedRequiredDocument,
    VoucherPrintContent,
    VisaNumberPrintContent,
    ReciprocityVisaDuration,
    ReciprocityVisa,
    ReciprocityDurationModal,
    TransferToNewDialog,
    VisaTippaniDialog,
    AttachFileDialog,
    ApplyPenaltyDialog,
    TravellerDetail,
    "tourist-visa": TouristVisa,
    "approve-modal-ui": VisaApproveModal,
    "reject-modal-ui": VisaRejectModal,
    "study-visa": StudyVisa,
    "business-visa": BusinessVisa,
    "relation-visa": RelationVisa,
    "transit-visa": TransitVisa,
    "marriage-visa": MarriageVisa,
    "residential-visa": ResidentialVisa,
    "nrn-visa": NRNVisa,
    "press-visa": PressVisa,
    "working-visa": WorkingVisa,
    "dependent-visa": DependentVisa,
    "official-visa": OfficialVisa,
    "diplomatic-visa": DiplomaticVisa,
    "dependent-study-visa": DependentStudyVisa,
    "dependent-working-visa": DependentWorkingVisa,
    "dependent-business-visa": DependentBusinessVisa,
    "dependent-marriage-visa": DependentMarriageVisa,
    "dependent-press-visa": DependentPressVisa,
    "dependent-relation-visa": DependentRelationVisa,
    "dependent-diplomatic-visa": DependentDiplomaticVisa,
    "dependent-official-visa": DependentOfficialVisa,
    ConfirmationHeaderText,
    ListItemDetail,
    FileDisplay,
    AvatarImageModal,
    DialogFile,
    PaymentDetail,
    VisaCancelModal,
    FileListItemDetail,
    AttachedDocument,
    BlackListDetail,
    UnapprovedVisaEditDialog,

    ManualPaymentDialog,
    ExtendConvertTippaniPrintContent,
    CostExemptionDialog,
    ForwardToUserDialog
  },
  computed: {
    ...mapGetters("AuthUser", ["user"]),
    statusColor() {
      if (this.latest_status.toLowerCase().includes("approved")) {
        return "success";
      } else if (this.latest_status.toLowerCase().includes("approved")) {
        return "success";
      } else if (this.latest_status.toLowerCase().includes("removed")) {
        return "error";
      }
      {
        return "primary";
      }
    },
    showPrintTippani() {
      // visa_request.tippani_generated
      const {tippani_generated, approve_rejected, automation_enabled, isTippaniVerified} = this.visa_request;

      if (!automation_enabled) {
        return tippani_generated && !approve_rejected;
      }
      return tippani_generated && !approve_rejected && isTippaniVerified
    },
    latest_status() {
      const latest_status = this.visa_request.visaHistory[0];
      let deleted_tracks = this.visa_request.visaHistory.filter(
          (i) => i.deletable && i.deleted_at > latest_status.created_at
      );

      if (deleted_tracks.length > 0) {
        deleted_tracks.sort(
            (a, b) => Date.parse(b.deleted_at) - Date.parse(a.deleted_at)
        );
        return deleted_tracks[0].status + " Removed";
      }
      return latest_status.status;
    },
    showLateDays() {
      return (
          this.visa_request.late_days > 0 && !this.visa_request.approve_rejected
      );
    },
    showVerifiedLateDays() {
      return (
          this.visa_request.verified_late_days > 0 &&
          !this.visa_request.approve_rejected
      );
    },
    showApplyBorderPenalty() {
      let {
        border_penalty_applied,
        submission_no,
        paid,
        voucher_generated,
      } = this.visa_request;
      submission_no = submission_no.substring(0, 1);
      return (
          !border_penalty_applied &&
          submission_no === "V" &&
          !paid &&
          !voucher_generated &&
          this.$oauth.checkIfHasPermission("apply border-penalty")
      );
    },
    fileAlreadyAttached() {
      const {file_attached} = this.visa_request;
      return file_attached;
    },
    visa_type_slug() {
      console.log(this.visa_request.dependent_visa);
      if (this.visa_request.dependent_visa.full_name !== undefined) {
        return "dependent-visa";
      }
      if (this.visa_request.dependent_visa === 1) {
        return "dependent-visa";
      }
      return this.visa_request.visaType.slug;
    },
    showDependentApproveMessage() {
      if (this.visa_request.dependent_visa.full_name !== undefined) {
        if (this.visa_request.dependent_visa.visa_number !== null) {
          var start_sub_number = null;
          start_sub_number = this.visa_request.dependent_visa.visa_number.substring(
              0,
              1
          );
          return start_sub_number === "C" || start_sub_number === "E";
        } else {
          start_sub_number = this.visa_request.dependent_visa.submission_no.substring(
              0,
              1
          );
          return start_sub_number === "C" || start_sub_number === "E";
        }
      }
      return false;
    },
    showApprove() {
      const {
        approve_rejected,
        file_attached,
        voucher_generated,
        paid,
        tippani_not_required,
        tippani_generated,
        check_payment_status_only,
        visa_number,
        can_approve_visa,
      } = this.visa_request;
      const amount = this.total;
      let showApprove =
          !approve_rejected &&
          (tippani_generated || tippani_not_required) &&
          can_approve_visa &&
          !check_payment_status_only &&
          !visa_number &&
          can_approve_visa;
      if (amount > 0) {
        showApprove = showApprove && voucher_generated && paid;
      }

      const visa_type = this.visa_request.visaType.slug;

      if (visa_type !== "tourist-visa") {
        showApprove = showApprove && file_attached;
      }
      return showApprove && !this.showDependentApproveMessage;
    },
    showGenerateTouristVisa(){
      const visa_slugs = ['relation-visa', 'marriage-visa'];
      // let visaHistory = this.visa_request.visaHistory
      // const visa_generated = visaHistory.find(x => x.statusNumber == 81)
      if(this.visa_request.visaType && this.visa_request.visaType.slug){
        return (
            visa_slugs.includes(this.visa_request.visaType.slug)
            && this.visa_request.late_days > 365
            // && !visa_generated
        )
      } else {
        return false
      }
    },
    showGenerateTippani() {
      if (!this.visa_request.automation_enabled) {
        return (
            !this.visa_request.check_payment_status_only &&
            !this.visa_request.tippani_not_required &&
            !this.visa_request.visa_number
        );
      } else {
        return (
            !this.visa_request.isTippaniVerified &&
            !this.visa_request.check_payment_status_only &&
            !this.visa_request.tippani_not_required &&
            !this.visa_request.visa_number
        );
      }
    },
    showApproveTippani() {
      return (
          this.visa_request.automation_enabled &&
          this.visa_request.assignee_user &&
          this.visa_request.assignee_user.id === this.user.id &&
          this.visa_request.assignee_user.purpose === 2 &&
          !this.visa_request.tippani_not_required &&
          !this.visa_request.visa_number &&
          !this.visa_request.approve_rejected
      );
    },
    showForward() {
      if (this.visa_request.automation_enabled) {
        return (
            this.visa_request.isTippaniVerified &&
            !this.visa_request.check_payment_status_only &&
            !this.visa_request.tippani_not_required &&
            !this.visa_request.visa_number
        )
      }
      return false
    },
    total() {
      const {
        amount,
        late_stay_cost,
        penalty_cost,
        transfer_cost,
        exempt_cost,
      } = this.visa_request.payment_detail;
      let total = parseFloat(amount);
      if (late_stay_cost !== undefined) {
        total = total + parseFloat(late_stay_cost);
      }
      if (penalty_cost !== undefined) {
        total = total + parseFloat(penalty_cost);
      }
      if (transfer_cost !== undefined) {
        total = total + parseFloat(transfer_cost);
      }
      if (exempt_cost !== undefined) {
        total = total - exempt_cost;
      }
      return total;
    },

    showTransferToNewPassport() {
      const {
        visa_number,
        visaType,
        transferred_to_new_passport,
        tippani_generated,
        paid,
      } = this.visa_request;
      return (
          !visa_number &&
          !tippani_generated &&
          !transferred_to_new_passport &&
          !paid
      );
    },
    can_generate_voucher() {
      let {visaHistory, paid, voucher_generated} = this.visa_request;
      const voucher_generated_track = visaHistory.find(
          (item) => item.statusNumber === 48
      );
      // if (voucher_generated_track !== undefined) {
      //   let voucher_created_at = voucher_generated_track.created_at.substr(0, 10);
      //   if (voucher_created_at !== new Date().toISOString().substring(0, 10)) {
      //     voucher_generated = false;
      //   }
      // }
      if (voucher_generated_track !== undefined) {
        voucher_generated = false;
      }
      const {tippani_generated, tippani_not_required, automation_enabled, isTippaniVerified} = this.visa_request;
      if (!automation_enabled) {
        return (
            !paid &&
            !voucher_generated &&
            (tippani_generated || tippani_not_required) &&
            this.total > 0
        );
      } else {
        if (tippani_generated) {
          return (
              !paid &&
              !voucher_generated &&
              (tippani_generated && isTippaniVerified) &&
              this.total > 0
          );
        } else {
          return (
              !paid &&
              !voucher_generated &&
              (tippani_generated || tippani_not_required) &&
              this.total > 0
          );
        }
      }
    },
    check_payment_status() {
      let {
        paid,
        voucher_generated,
        tippani_generated,
        tippani_not_required,
      } = this.visa_request;
      return (
          !paid &&
          voucher_generated &&
          (tippani_generated || tippani_not_required)
      );
    },
    tippanis() {
      return this.$store.state.Tippani.tippanis;
    },
    gratisVisaNumber() {
      const {amount, penalty_cost} = this.visa_request.payment_detail;
      const {submission_no} = this.visa_request;
      if (this.total === 0 || amount - penalty_cost === 0)
        return "G" + submission_no;

      return "";
    },
    isGratis() {
      let applied_track = this.visa_request.visaHistory.find((item) => {
        return (
            item.statusNumber === 0 ||
            item.statusNumber === 8 ||
            item.statusNumber === 9
        );
      });

      let cost_exempted_track = this.visa_request.visaHistory.find((item) => {
        return item.statusNumber === 46;
      });
      let visa_fee = applied_track.cost;
      console.log(" Amount::: " + applied_track.status);
      console.log(" Amount::: " + applied_track.cost);
      // console.log(" Amount::: " + amount===undefined)
      if (visa_fee > 0 && !cost_exempted_track) {
        return 0;
      }
      if (cost_exempted_track) {
        if (this.visa_request.payment_detail) {
          let {
            plan_charge,
            transfer_cost,
            exempt_cost,
            border_penalty,
            amount,
            late_stay_cost,
            penalty_cost,
          } = this.visa_request.payment_detail;
          if (
              plan_charge +
              transfer_cost +
              border_penalty +
              amount +
              late_stay_cost +
              penalty_cost -
              exempt_cost ===
              0
          ) {
            return 1;
          } else {
            return 0;
          }
        }
      }
      return 1;
    },
    penaltyApplied() {
      let expire_date = this.visa_request.expiry_date
          ? this.visa_request.expiry_date
          : this.expiryDate;
      let {
        paid,
        voucher_generated,
        tippani_generated,
        tippani_not_required,
        late_days,
        payment_detail,
        approve_rejected,
        submission_no,
        office_slug,
        isTippaniVerified,
        visaType,
      } = this.visa_request;

      submission_no = submission_no.substr(0, 1);
      return (
          (!paid &&
              !voucher_generated &&
              tippani_generated &&
              (late_days || (submission_no === "V" && office_slug === "DoI")) &&
              !payment_detail.penalty_applied &&
              !approve_rejected) ||
          (moment(expire_date).isAfter("2020-12-15") &&
              !paid &&
              !voucher_generated &&
              !payment_detail.penalty_applied &&
              !approve_rejected &&
              visaType.slug === "tourist-visa")
      );
    },
    showPenalty() {
      let {
        paid,
        voucher_generated,
        tippani_generated,
        tippani_not_required,
        late_days,
        payment_detail,
        approve_rejected,
        submission_no,
        office_slug,
        isTippaniVerified,
        assignee_user
      } = this.visa_request;

      submission_no = submission_no.substr(0, 1);

      const commonConditions = (
          !paid &&
          !voucher_generated &&
          (late_days || (submission_no === "V" && office_slug === "DoI")) &&
          !payment_detail.penalty_applied &&
          !approve_rejected
      );

      if (!this.visa_request.automation_enabled) {
        return commonConditions && (tippani_generated || tippani_not_required);
      } else {
        if (tippani_generated) {
          return (
              commonConditions &&
              isTippaniVerified &&
              tippani_generated &&
              (
                  (assignee_user && assignee_user.purpose_name === 'Penalty' && assignee_user.id === this.user.id) ||
                  [3, 4].includes(parseInt(this.user.level))
              )
          )
        } else {
          return commonConditions && (tippani_generated || tippani_not_required)
        }
      }

    },

    showPenaltyTemporarily() {
      let expire_date = this.visa_request.expiry_date
          ? this.visa_request.expiry_date
          : this.expiryDate;

      let {
        paid,
        voucher_generated,
        payment_detail,
        approve_rejected,
        visaType,
        automation_enabled,
        isTippaniVerified,
        assigned_user_for_penalty
      } = this.visa_request;

      if (!automation_enabled) {
        return (
            moment(expire_date).isAfter("2020-12-15") &&
            !paid &&
            !voucher_generated &&
            !payment_detail.penalty_applied &&
            !approve_rejected &&
            visaType.slug === "tourist-visa"
        );
      } else {
        return (
            isTippaniVerified &&
            moment(expire_date).isAfter("2020-12-15") &&
            !paid &&
            !voucher_generated &&
            !payment_detail.penalty_applied &&
            !approve_rejected &&
            visaType.slug === "tourist-visa" &&
            assigned_user_for_penalty && assigned_user_for_penalty.id === this.user.id

        );
      }
    },

    showAttachDocuments() {
      const {
        approve_rejected,
        paid,
        can_attach_file,
        payment_detail,
      } = this.visa_request;

      // if (parseInt(payment_detail.amount) === 0) {
      //   return !approve_rejected && can_attach_file;
      // }
      // return !approve_rejected && can_attach_file;
      return can_attach_file;
    },
    selectedTippani: {
      get() {
        return this.$store.state.Tippani.selectedTippani;
      },
      set(value) {
        this.$store.commit(SET_SELECTED_TIPPANI, value);
      },
    },
    visa_types() {
      return this.$store.state.VisaTypeList.all;
    },
    canExemptCost() {
      const {
        visa_number,
        tippani_generated,
        tippani_not_required,
        cost_exempted,
        check_payment_status_only,
        payment_detail,
      } = this.visa_request;
      return (
          !visa_number &&
          !tippani_generated &&
          !tippani_not_required &&
          !cost_exempted &&
          !check_payment_status_only &&
          !payment_detail.total > 0
      );
    },
    expiryDate() {
      return moment(this.visa_request.start_date)
          .add(this.visa_request.duration, "days")
          .subtract(1, "days")
          .format("YYYY-MM-DD");
    },

    showApplyForExtension() {
      const {
        visa_number,
        cancelled,
        submission_no,
        office_slug,
      } = this.visa_request;
      return (
          visa_number &&
          !cancelled &&
          submission_no.substr(0, 1) === "V" &&
          office_slug === "DoI"
      );
    },
    showTippaniVerification() {
      return (
          this.visa_request.automation_enabled &&
          this.visa_request.assignee_user &&
          this.visa_request.assignee_user.id === this.user.id &&
          this.visa_request.assignee_user.purpose === 0 &&
          !this.visa_request.tippani_not_required &&
          !this.visa_request.visa_number &&
          !this.visa_request.approve_rejected
      );
    },
  },
  methods: {
    ...mapActions("VisaRequestSingle", [
      "getVisaRequestDetail",
      "makePayment",
      "submitTippani",
      "checkPaymentStatus",
      "generateVoucher",
      "paymanually",
      "proceedWithoutTippani",
      "applyBorderPenalty",
      "generateVisaPrintedTrack",
      "printVisaNumber",
      "approveTippani",
      "regulateThroughTouristVisa",
    ]),
    ...mapActions({
      updateTraveller: "VisaRequestSingle/updateTraveller",
      updatePreviousStay: "VisaRequestSingle/updatePreviousStay",
    }),
    viewVisaRequest(submission_no) {
      console.log(submission_no)
      this.$router.push({name: 'ViewVisaRequest', params: {id: submission_no}});
      this.getVisaRequestDetail(submission_no);
    },
    async showAddBorderPenalty() {
      const {submission_no} = this.visa_request;

      await this.$dialog.confirm({
        text:
            "Are you sure you want to add border penalty . This will add 50% of visa cost as penalty",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.applyBorderPenalty();
            },
          },
        },
      });
    },
    attachDocument() {
      this.attachFileDialog = true;
    },
    async confirmUpdatePreviousStay() {
      await this.$dialog.confirm({
        text: "Are you sure want to update year log ?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.updatePreviousStay();
            },
          },
        },
      });
    },
    exemptCost() {
      this.exemptionDialog = true;
    },
    proceedCompletedPurpose(data = null) {
      this.getVisaRequestDetail(this.visa_request.submission_no);
      if (this.visa_request.automation_enabled) {
        if (data && data === 'verify-tippani') {
          this.forwardToUser()
        }
      }
    },
    costExempted(data = null) {
      this.getVisaRequestDetail(this.visa_request.submission_no);
      if (data && data === 'penalty' && this.visa_request.automation_enabled) {
        this.showForwardToUserModal = true;
        this.forwardPurpose = 'Approve'
      }
    },
    payManually() {
      this.manualPaymentDialog = true;
    },
    cancelTippani() {
      if (this.step === 1) {
        this.tippaniDialog = false;
      } else {
        this.hide = false;
        this.step = 1;
      }
    },
    proceed() {
      const tippani = this.quill.root.innerHTML;
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.hide = true;
      this.step = 2;
    },
    approve() {
      this.$store.commit("VisaRequestSingle/setApproveModal", true);
    },
    download() {
      this.$store.dispatch("VisaRequestSingle/downloadVisaDetails");
    },
    showTransferToNewPassportDialog() {
      this.transferToNewDialog = true;
      // return  false;
      return this.visa_request.visaType.slug !== "tourist-visa";
    },
    printTippani() {
      window.print();
    },
    async approveTippaniGenerated() {
      await this.$dialog.confirm({
        text:
            "Are you sure you want to approve tippani?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.approveTippani().then(r => {
                this.forwardToUser()
              });
            },
          },
        },
      });
    },
    async forwardToUser() {
      if (this.penaltyApplied) {
        this.forwardPurpose = 'Penalty'
      } else {
        this.forwardPurpose = 'Approve'
      }
      this.showForwardToUserModal = true;
    },
    async checkPayment() {
      try {
        await this.checkPaymentStatus();
        this.$store.commit("Notification/showSuccess", "Amount has been paid");
      } catch (e) {
        this.$store.commit("Notification/showError", "The amount is unpaid");
      }
    },
    async generateTouristVisa() {
      await this.$dialog.confirm({
        text: "Are you sure you want to generate Tourist Visa?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              try {
                this.regulateThroughTouristVisa().then(res => {
                  const data = res.data.data
                  let routeData = this.$router.resolve({name: 'BarCode', query: {bar_code: data.submission_no}});
                  window.open(routeData.href, '_blank');
                });
              } catch (e) {
              }
            },
          },
        },
      });
    },
    async generateTippani() {
      this.randomTippaniKey = new Date().toUTCString();
      this.tippaniDialog = true;
    },
    verifyTippaniGenerated() {
      this.$store.commit("VisaRequestSingle/setTippaniVerificationModal", true);
      this.tippaniPurpose = 'verify-tippani'
    },
    reject() {
      this.$store.commit("VisaRequestSingle/setRejectModal", true);
    },
    cancel() {
      this.$store.commit("VisaRequestSingle/setCancelModal", true);
    },
    view(submission_no) {
      window.open(
          "/admin/system/visa-requests/view/" + submission_no,
          "_blank"
      );
    },
    viewHistory(visa_request) {
      window.open(
          "/admin/system/travellers-history/view/" + visa_request.traveller.id
      );
    },
    async doNotGenerateTippani() {
      await this.$dialog.confirm({
        text: "Are you sure you want to proceed without tippani ?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              try {
                await this.proceedWithoutTippani();
              } catch (e) {
              }
            },
          },
        },
      });
    },
    applyForExtension() {
      const {visa_number, documents, office_slug} = this.visa_request;
      let passport_number = documents[0].number;
      const url =
          "https://nepaliport.immigration.gov.np/visa-processing?visa_number=" +
          visa_number +
          "&passport_number=" +
          passport_number +
          "&office=" +
          office_slug;
      window.open(url, "_blank");
    },
    unmarked(id) {
      this.visa_request.blacklists = this.visa_request.blacklists.filter(
          (i) => i.id === id
      );
    },
    print(type) {
      if (type === "tippani") {
        const content = document.getElementById("tippani_content").innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content);
      }

      if (type === "visa_number") {
        const content = document.getElementById("visa_number_print_content")
            .innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content);
        this.$store.commit(SET_PRINT_TYPE, "visa_number");
      }
      if (type === "initial_visa_number") {
        const content = document.getElementById("visa_number_print_content")
            .innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content);
        this.$store.commit(SET_PRINT_TYPE, "visa_number");
        setTimeout(() => {
          window.print();
        }, 100);
        // this.generateVisaPrintedTrack()
        //     .then(() => {
        //       setTimeout(() => {
        //         window.print()
        //       }, 100);
        //       this.$store.commit("Notification/showSuccess", "Visa printed track generated successfully");
        //     })
        //     .catch(error => {
        //       this.$store.commit('Notification/showError', error.response.data.message)
        //     });
      }
      if (type === "initial_tippani") {
        const content = document.getElementById("tippani_content").innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content);
        setTimeout(() => {
          window.print();
        }, 100);
      }

      if (type === "application_form") {
        const visa_request = this.$store.state.VisaRequestSingle.visaRequest;
        this.$store.commit(SET_PRINT_CONTENT, visa_request.application_form);
      }

      if (type === "voucher") {
        const content = document.getElementById("voucher_print_content")
            .innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content);
      }
    },
    editForm() {
      this.manualEditDialog = true;
    },
    printNow(o) {
      var self = this;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
        this.generateVisaPrintedTrack()
            .then(() => {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              //Set Printer type (Refer to the help, there many of them!)
              cpj.clientPrinter = 0;
              cpj.printerCommandsCodePage = -1;
              //Set printer commands...
              cpj.printerCommands = self.visa_request.prn_file_content;
              cpj.sendToClient();
              this.$store.commit('VisaRequestSingle/setVisaNumberModal', false)
              this.$store.commit("Notification/showSuccess", "Visa printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }

    },
    jspmWSStatus() {
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
        return true;
      else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        // alert(
        //     "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm"
        // );
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        // alert("JSPM has blocked this website!");
        return false;
      }
    },
    printVisa() {
      this.visaPrintLoading = true;
      this.printVisaNumber()
          .then(() => {
            this.visaPrintLoading = false;
            this.$store.commit(
                "Notification/showSuccess",
                "Visa printed successfully"
            );
          })
          .catch((error) => {
            this.visaPrintLoading = false;
            this.$store.commit(
                "Notification/showError",
                error.response.data.message
            );
          });
    },
  },
  mounted() {
    this.$store.dispatch("VisaTypeList/fetchAll");
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    const self = this;
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (self.jspmWSStatus()) {
        //get client installed printers
        JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          // var options = "";
          // for (var i = 0; i < myPrinters.length; i++) {
          //   options += "<option>" + myPrinters[i] + "</option>";
          // }
          console.log(myPrinters);
          // $("#installedPrinterName").html(options);
          self.printers = myPrinters;
        });
      }
    };
  },
  watch: {
    visa_request: {
      // the callback will be called immediately after the start of the observation
      deep: true,
      handler(val, oldVal) {
        if (
            val &&
            val.visa_type_condition &&
            val.visa_type_condition.is_reciprocity === 1 &&
            val.extra &&
            !val.extra.hasOwnProperty("reciprocity_visa")
        ) {
          this.$store.commit(
              "VisaRequestSingle/setReciprocityDurationModal",
              true
          );
        } else {
          this.$store.commit(
              "VisaRequestSingle/setReciprocityDurationModal",
              false
          );
        }
        // do your stuff
      },
    },
  },
};
</script>
